module.exports = __webpack_public_path__ + "static/assets/536929a6176219fb98d5aeb877bc2977.svg";